import * as React from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { GridCellProps } from '@progress/kendo-react-grid';

interface IDDProps extends GridCellProps {
    dropDownData: any;
    textfield: string;
    valuefield: string;
    isDisabled: boolean;
}

export default class DropDownCell extends React.Component<IDDProps, {}> {

    public handleChange = (e: any) => {
        if (this.props.onChange) {
            this.props.onChange({
                dataItem: this.props.dataItem,
                dataIndex: this.props.dataIndex,
                field: this.props.field,
                syntheticEvent: e.syntheticEvent,
                value: e.target.value[this.props.valuefield]
            });
        }
    }


    public render() {

        const dvalue: any = this.props.field ? this.props.dataItem[this.props.field] : undefined;
        let findValue: any = this.props.dropDownData.find((g: any) => g[this.props.valuefield] === dvalue);
        // There is an issue if left undefined so set to an empty object to clear the selected value
        if (!findValue) {
            findValue = {};
        }

        return (
            <DropDownList
                style={{ width: "100%" }}
                onChange={this.handleChange}
                value={findValue}
                data={this.props.dropDownData}
                textField={this.props.textfield}
                dataItemKey={this.props.valuefield}
                disabled={this.props.isDisabled}
            />
        );
    }

}